import { SET_PROMOTION, RESET_PROMOTION } from "../actions/promotion";

const initialState = [];

const service = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROMOTION:
      return [...action.payload];
    case RESET_PROMOTION:
      return initialState;
    default:
      return state;
  }
};

export default service;



// WEBPACK FOOTER //
// ./src/store/reducers/promotion.js